/**
 * Regex Test if String is camelCased
 * @function isCamelCase
 * @param {string} str
 * @return {boolean}
 */
const isCamelCase = str => /([a-z])([A-Z])/g.test(str);

export default isCamelCase;
